import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { media } from 'styles/media'

import HelpCard from '../../../components/cards/HelpCard'
import ButtonLink from '../../../components/display/ButtonLink'
import SimpleA from '../../../components/display/SimpleAnchor'

const Heading = styled.h4`
  font-size: ${({ theme }) => theme['-ds-font-size-md']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-xl']['font-weight'].value};
  color: ${({ theme }) => theme['-ds-core-300'].value};
  line-height: 1.7;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-xl']['font-size'].value};
  `}
`

const Text = styled.div`
  font-size: ${({ theme }) => theme['-ds-font-size-xs']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-sm']['font-weight'].value};
  line-height: 1.6;
  text-align: center;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-md']['font-size'].value};
  `}
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 950px;
  margin: 0 auto;
  padding: 0;

  ${ButtonLink} {
    margin-top: 40px;
  }

  ${media.md`
    padding: 30px 0;
  `}
`

const Help = () => {
  const [t] = useTranslation()

  return (
    <HelpCard>
      <ContentWrapper>
        <Heading>We&apos;re here to support you</Heading>
        <Text>
          Need help signing up as a host or setting up your listing? Our Support
          Team are always on hand to answer your questions. Just contact them
          via live chat, or visit our{' '}
          <SimpleA
            href="http://help.riparide.com/en/collections/78185-hosting-with-riparide"
            target="_blank"
            rel="noopener noreferrer"
            textDecoration="none"
          >
            {t('helpCenter.name')}
          </SimpleA>
          .
        </Text>
      </ContentWrapper>
    </HelpCard>
  )
}

export default Help
